export const getters = {
  getMenuItems: state => state.menuItems,
  getMenuItemByName: state => name => state.menuItems.find(item => item.name === name),
  getSections: state => state.sections,
  getSectionsLoadingStatus: state => state.sectionsLoadingStatus,
  getFormProgress: state => state.formProgress,
  getStates: state => state.states,
  getZipCodeData: state => state.zipCodeData,
  getZipCodeLoading: state => state.zipCodeLoading,
  getAppProducts: state => state.appProducts,
  getIsAppAccessPaid: state => state.isAppAccessPaid,
  getAppAccessType: state => state.appAccessType,
  getOrders: state => state.orders,
  getEasyFilingPaid: state => state.isEasyFilingPaid,
  getPersonalEditLimit: state => state.isPersonalEditLimited,
  getAddressEditLimit: state => state.isAddressEditLimited,
  getCurrentYearUserApplicationId: state => state.currentYearUserApplicationId,
  getCurrentApplicationData: state => state.currentApplicationData,
  getApplicationAccessStatus: state => state.applicationAccessStatus,
  getIsAppClosed: state => state.isAppClosed,
};
